export function formatFlow(value: number): string {
  const amount = Math.abs(value) / 100_000_000
  const decimals = amount >= 100 ? 0 : amount >= 10 ? 1 : 2
  const sign = value > 0 ? '+' : value < 0 ? '−' : ''
  return `${sign}${amount.toFixed(decimals).replace(/\.0+$/, '')}亿`
}

export function formatPercent(value: number): string {
  const arrow = value >= 0 ? '▲' : '▼'
  return `${arrow}${Math.abs(value).toFixed(2)}%`
}

export function formatSectorDisplayName(name: string): string {
  const original = name.trim()
  const displayName = original
    .replace(/(?:\s*(?:概念|[ⅠⅡⅢ]|(?<![A-Za-z])I{1,3}))+\s*$/u, '')
    .trim()
  return displayName || original
}

export function formatDateForFile(isoDate: string): string {
  return isoDate.replace(/[^0-9-]/g, '')
}
